import {createStore} from '@web/helpers/redux'

import {RootState} from '../../interfaces'

import Middlewares, {DefaultMiddlewareOptions} from './middlewares'
import createRootReducer from './reducer'
import SentryEnhancer from './sentryEnhancer'

const store = createStore<RootState>({
    rootReducerCreator: createRootReducer,
    middlewares: Middlewares,
    sentryEnhancerOptions: SentryEnhancer,
    defaultMiddlewareOptions: DefaultMiddlewareOptions,
})

export default store
